var _excluded = ["children", "cols", "css"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { Div } from '@kizi/core-components';
var baseContainerProps = {
  display: 'grid',
  gridAutoRows: '1fr',
  css: {
    '& > *': {
      minWidth: 0
    }
  }
};

var getGridTemplateColumns = function getGridTemplateColumns(col) {
  return col ? "repeat(".concat(col, ", 1fr);") : null;
};

export var Row = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      cols = _ref.cols,
      css = _ref.css,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var containerProps = useMemo(function () {
    var gridTemplateColumns = Array.isArray(cols) ? cols.map(function (col) {
      return getGridTemplateColumns(col);
    }) : getGridTemplateColumns(cols);
    return _objectSpread(_objectSpread(_objectSpread({}, divProps), baseContainerProps), {}, {
      css: _objectSpread(_objectSpread({}, baseContainerProps.css), css),
      gridTemplateColumns: gridTemplateColumns
    });
  }, [children]);
  return (
    /*#__PURE__*/
    // TODO: remove display={['block', 'block', 'grid']} and replace with <Row cols={[1, 1, actualColsNumber]} />
    // where the component is called and needs to have a 1 col width
    React.createElement(Div, _extends({}, containerProps, {
      display: ['block', 'block', 'grid'],
      ref: ref
    }), children)
  );
});